import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import myAxios from '../../../../lib/axios';


const initialState = {
    data: [],
};

export const fetchCoverLetter = createAsyncThunk(
    'masters/fetchCoverLetter',
    async (query) => {
        try {
            const response = await myAxios.get(`/cover-letter/all`);

            return { success: true, message: "CoverLetters fetched successfully!", data: response?.data?.coverLetters };
        } catch (error) {
            if (error?.response?.data) {
                return { success: false, message: error?.response?.data?.message };
            } else {
                return { success: false, message: 'Sorry, something went wrong!' };
            }
        }
    },
);





const coverLetterSlice = createSlice({
    name: 'coverLetter',
    initialState,
    reducers: {
        clearCoverLetterData: state => {
            state.data = [];
        },
        setCoverLetterData: (state, action) => {
            state.data = action.payload;
        },

    },
});

export const coverLetterReducer = coverLetterSlice.reducer;
export const { clearCoverLetterData, setCoverLetterData } = coverLetterSlice.actions;

export const selectCoverLetterData = (state) => state.coverLetter.data;
